import { S3_FOLDER_URL } from "Config";
import _ from "i18n";
import { TEMPLATE_TYPES } from "../constants";
import { formatDateFromTo, formatTime, getUserNameForAvatar } from "./utils";
export const isEmpty = (value) => {
  if (Array.isArray(value) || typeof value === "string") {
    return value.length === 0;
  }
  if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0;
  }
  return !value;
};
export function isUrl(str) {
  const regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

  return regexp.test(str);
}

export const trimUrlSlashes = (url) => url.replace(/^\/+|\/+$/g, "");

export const prepareS3ResourceUrl = (
  baseS3Url,
  urlPath,
  appendEventsFolder = true,
) => {
  if (isUrl(urlPath ?? "")) return urlPath;
  if (isEmpty(baseS3Url) || isEmpty(urlPath) || !baseS3Url || !urlPath)
    return "";

  const base = trimUrlSlashes(baseS3Url);
  const path = trimUrlSlashes(urlPath).replace("eventsFolder", "events-folder");
  const pathPrefix =
    appendEventsFolder && path.split("/")[0] !== "events-folder"
      ? "events-folder"
      : "";

  return `${base}${isEmpty(pathPrefix) ? "/" : `/${pathPrefix}/`}${path}`;
};

export const formatTaxtvshow = (taxtvshow) => {
  let {
    id,
    nameFr,
    isVirtual,
    startDateTime,
    endDateTime,
    memberPrice,
    nonMemberPrice,
    languages,
  } = taxtvshow;
  const getBannerImageUrl = (taxtvshow) => {
    const imageUrl = taxtvshow.urlBannerFr || taxtvshow.pictureUrlFr;
    return prepareS3ResourceUrl(S3_FOLDER_URL, imageUrl);
  };

  const bannerImgUrl = getBannerImageUrl(taxtvshow);
  let mode = "";
  mode = isVirtual ? "PROCHAINEMENT EN live" : "PROCHAINEMENT EN Présentiel";

  let location = taxtvshow.isVirtual ? "En live" : "Sur place";
  let speakerEventName = "";
  let speakerPhoto = "";

  let speakers = taxtvshow["speakers-abstract"]?.speakers || [];

  if (speakers.length > 0) {
    let firstSpeaker = speakers[0];
    speakerEventName =
      `${firstSpeaker.firstName || ""} ${firstSpeaker.lastName || ""}`.trim();

    speakerPhoto = firstSpeaker.pictureUrl ? firstSpeaker.pictureUrl : "";
  }

  let eventUrl =
    taxtvshow.urlBadgeFr && taxtvshow.urlBadgeFr.startsWith("http")
      ? taxtvshow.urlBadgeFr
      : "";

  let taxtvshowPlace = taxtvshow.placeFr || "";
  let taxtvshowReplay =
    taxtvshow.isReplayable === 1 ? "comprend l'option: replay" : taxtvshowPlace;

  const defaultLogos = {
    9: "https://s3.tamtam.pro/local/storage/media/IMAGE/2174/AVATAR_54cbd68e1ba9284a1e486bd5d8551259cd51d96e.png",
    1256: "https://s3.tamtam.pro/local/storage/media/IMAGE/6348/AVATAR_e4fb37d14607091b2d1057ac4aa3b56c60e12f77.png",
  };

  let fiduciaireLogo = "";

  if (taxtvshow.type === "formation") {
    fiduciaireLogo = taxtvshow.clientData?.avatarUrl || "";
  } else {
    fiduciaireLogo = defaultLogos[taxtvshow.client] || "";
  }

  let formattedEventDate = formatDateFromTo(startDateTime, endDateTime);

  let formattedStartTime = formatTime(startDateTime);

  let formattedEndTime = formatTime(endDateTime);

  const parsedLanguages = JSON.parse(languages);
  const languageKey = Object.keys(parsedLanguages)[0].toLowerCase();

  function getSpeakerImageBlock(speakerPhoto) {
    if (!speakerPhoto) {
      return "";
    }

    return `
      <img
        src="${speakerPhoto}"
        alt="Speaker"
        width="26"
        height="26"
        style="border-radius: 50%; display: inline-block; background-color: #ffffff; vertical-align: middle;"
      >
  `;
  }
  const formattedBlockImg = getSpeakerImageBlock(speakerPhoto);
  const getSpeakersHtmlFromTaxTvShow = (taxtvshow) => {
    const speakers = taxtvshow["speakers-abstract"]?.speakers || [];
    if (!speakers.length) return "";
    const filteredSpeakers = speakers.filter((s) => s.userId !== "8650");

    const speakerTemplate = (speaker) => {
      const hasAvatar = !!speaker.pictureUrl;
      const firstName = speaker.firstName || "";
      const lastName = speaker.lastName || "";
      const fullName = `${firstName} ${lastName}`.trim();
      const initials = getUserNameForAvatar(fullName);

      return `
      <table cellpadding="0" cellspacing="0" border="0"
        style="display:inline-block; vertical-align:middle; margin-right:20px; margin-bottom:10px; text-align:left;">
        <tr>
          <td valign="middle">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td align="center" valign="middle">
                  ${
                    hasAvatar
                      ? `<table cellpadding="0" cellspacing="0" border="0"
                            style="border-radius:50%; background:linear-gradient(180deg,#18a0fb,#06d9b1); padding:2px;">
                            <tr>
                              <td align="center" valign="middle" style="border-radius:50%; background-color:#fff;">
                                <img src="${speaker.pictureUrl}" width="45" height="45"
                                  style="display:block; border-radius:50%; object-fit:cover;" alt="${fullName}">
                              </td>
                            </tr>
                          </table>`
                      : `<table cellpadding="0" cellspacing="0" border="0"
                            style="width:49px; height:49px; border-radius:50%; background:linear-gradient(180deg,#18a0fb,#06d9b1); padding:2px;">
                            <tr>
                              <td align="center" valign="middle" style="border-radius:50%; background-color:#fff;">
                                <table cellpadding="0" cellspacing="0" border="0" width="45" height="45"
                                  style="border-radius:50%; background-color:#ffffff;">
                                  <tr>
                                    <td align="center" valign="middle"
                                      style="font-size:14px; font-weight:700; color:#b2bcc6; line-height:45px; mso-line-height-rule:exactly;">
                                      ${initials}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>`
                  }
                </td>
                <td valign="middle" style="padding-left:10px; padding-top:10px;">
                  <div style="font-family:Arial,sans-serif; font-size:13px; color:#1b2a38;">${firstName}</div>
                  <div style="font-family:Arial,sans-serif; font-size:13px; font-weight:bold; color:#1b2a38;">${lastName}</div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    `;
    };

    return `
    <table cellpadding="0" cellspacing="0" border="0" width="100%">
      <tr>
        <td align="left" valign="top" style="font-size:0; text-align:left;">
          ${filteredSpeakers.map((s) => speakerTemplate(s)).join("")}
        </td>
      </tr>
    </table>
  `;
  };
  const speakerTaxtvshowHtml = getSpeakersHtmlFromTaxTvShow(taxtvshow);
  return {
    id,
    type: TEMPLATE_TYPES["TAXTVSHOW_LAYOUT"],
    taxtvshowNameFr: nameFr || "",
    taxtvshowMode: mode,
    speakerTaxtvshowName: speakerEventName,
    speakerTaxtvshowPhoto: formattedBlockImg,
    taxtvshowLocation: location,
    taxtvshowDate: formattedEventDate,
    taxtvshowStartTime: formattedStartTime,
    taxtvshowEndTime: formattedEndTime,
    taxtvshowPrice:
      nonMemberPrice !== undefined && nonMemberPrice !== null
        ? `${nonMemberPrice}`
        : "0",
    taxtvshowMemberPrice:
      memberPrice !== undefined && memberPrice !== null
        ? `${memberPrice}`
        : "0",
    taxtvshowFiduciaireLogo: fiduciaireLogo,
    taxtvshowImage: bannerImgUrl,
    urlTaxtvshow: `https://offfcourse.be/${languageKey}/event/${id}/reception`,
    taxtvshowPlace,
    taxtvshowReplay,
    speakerTaxtvshowHtml,
  };
};
